import React from "react";
import ModalContainer from "../../common/ModalContainer";

function ClaimPointsModal({ open, setOpen, item }) {
  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      padding="px-4 py-6"
      title={"Odiopay ticket price lock service"}
      header={<></>}
      childClassname={"rounded-t-lg max-w-[600px]"}
      onClickOutside={() => setOpen(false)}
    >
      <div className="w-full flex flex-col">
        <div className="w-full">
          <div className="relative overflow-x-auto flex flex-col scroll-hide">
            <div className="flex flex-col p-4 w-full rounded-md">
              <div className="w-full flex flex-col gap-2 items-center">
                <img
                  src="/milesCoins.png"
                  alt=""
                  className="w-72 object-contain"
                />
                <div className="w-full flex items-center text-center justify-center font-black text-xl mt-2 text-primary1">
                  Intraverse Points Earned!
                </div>
                <div
                  className={`flex flex-1 w-full items-center flex-col py-2 mt-4 rounded-lg bg-[#06E775]/10`}
                >
                  <span className="max-w-[80%] text-black text-sm text-center mt-1">
                    You have earned <strong>+{item?.points}</strong> Intraverse
                    points
                  </span>
                </div>
                <hr className="w-full my-4 border border-gray-200" />
                <button
                  className="w-full h-12 text-white bg-primary1 rounded-md flex items-center justify-center"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default ClaimPointsModal;
